'use client';

import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, useEffect } from 'react';
import { useGuest } from '@/app/_hooks/useGuest';
import { useAuthStore } from '@/stores/AuthStore';
export const GuestProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const isLogin = useAuthStore(_temp);
  const {
    setGuestSessionId,
    getGuestSessionId,
    removeGuestSessionId
  } = useGuest();
  let t1;
  let t2;
  if ($[0] !== getGuestSessionId || $[1] !== isLogin || $[2] !== removeGuestSessionId || $[3] !== setGuestSessionId) {
    t1 = () => {
      if (isLogin === undefined) {
        return;
      }
      if (isLogin) {
        removeGuestSessionId();
        return;
      }
      if (getGuestSessionId()) {
        return;
      }
      setGuestSessionId();
    };
    t2 = [getGuestSessionId, isLogin, removeGuestSessionId, setGuestSessionId];
    $[0] = getGuestSessionId;
    $[1] = isLogin;
    $[2] = removeGuestSessionId;
    $[3] = setGuestSessionId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== children) {
    t3 = <>{children}</>;
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp(state) {
  return state.isLogin;
}